module.exports = __webpack_public_path__ + "static/media/reddit.259c6169.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/reddit.png
// module id = 405
// module chunks = 0